'use es6';

export const getCurrentTimestamp = () => {
  return Date.now();
};
export const getLatency = start => {
  return getCurrentTimestamp() - start;
};